export { TASK, SAGA_ACTION, noop, is, deferred, arrayOfDeffered, createMockTask } from './internal/utils';
export { asEffect } from './internal/io';
export { CHANNEL_END } from './internal/proc';


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/redux-saga/es/utils.js
// module id = 1048
// module chunks = 20